// Nether fauna (M17.1). PURE (ENG-1). The signature hoglin + strider rules the
// host drives each tick:
//  • a hoglin is repelled by warped fungus/roots and the blocks it associates with
//    escape, and — dragged into the overworld — zombifies into a zoglin;
//  • a strider is fire-immune (it lives on the lava seas), shivers and slows when
//    off lava, is hurt by water, and is steered faster with a warped fungus on a
//    stick while ridden.
import { NETHER_FAUNA } from '../config';

const HOGLIN_REPELLENTS = new Set(['warped_fungus', 'warped_roots', 'nether_portal', 'respawn_anchor']);

/** A hoglin flees from these (warped flora + the two "nether escape" blocks). */
export function hoglinRepelledBy(block: string): boolean {
  return HOGLIN_REPELLENTS.has(block);
}

/** A hoglin's zombify timer only runs outside the Nether. */
export function hoglinZombifyStarts(dimension: string): boolean {
  return dimension !== 'nether';
}

/** After this long in the overworld a hoglin turns into a zoglin. */
export function hoglinZombifies(overworldTicks: number): boolean {
  return overworldTicks >= NETHER_FAUNA.HOGLIN_ZOMBIFY_TICKS;
}

/** Striders are immune to fire/lava damage (they live on the lava seas). */
export function striderFireImmune(): boolean {
  return true;
}

/** A strider is cold (shivering) whenever it is not standing on lava. */
export function striderCold(onLava: boolean): boolean {
  return !onLava;
}

/** A cold strider walks slowly; a warm (on-lava) one moves at full speed. */
export function striderColdSpeed(cold: boolean): number {
  return cold ? NETHER_FAUNA.STRIDER_COLD_SPEED : 1;
}

/** Water hurts a strider on this cadence. */
export function striderHurtByWater(inWater: boolean, worldTick: number): boolean {
  return inWater && worldTick % NETHER_FAUNA.STRIDER_WATER_INTERVAL === 0;
}

/** A saddled strider steered with a warped fungus on a stick moves faster. */
export function striderSteerBoost(held: string): number {
  return held === 'warped_fungus_on_a_stick' ? NETHER_FAUNA.STRIDER_STEER_BOOST : 1;
}
